import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Objective from "../Objective/Objective";
import Subjective from "../Subjective/Subjective";
import "./question.scss";
import { useDispatch, useSelector } from "react-redux";
import { loadingDummy } from "../allQuestions";
import { updateAnswer } from "../../../redux/features/questions/questionSlice";
import QuestionImgModal from "../QuestionImgModal/QuestionImgModal";
import MultiSelect from "../MultiSelect/MultiSelect";
import Editor from "../Editor/Editor";

const alphabetArray = ["a", "b", "c", "d", "e", "f"];

const Question = ({ type }) => {
  //let getCurrentQuestionFromRedux;
  let dispatch = useDispatch();
  const { list, currentIndex } = useSelector((state) => state.questions);
  const [currentQuestion, setcurrentQuestion] = useState(loadingDummy);
  const [show, setShow] = useState(false);
  const handleImageModal = () => {
    setShow((x) => !x);
  };

  useEffect(() => {
    if (list.length) {
      setcurrentQuestion(list[currentIndex]);
    }
  }, [list, currentIndex]);

  const handleChange = (event) => {
    dispatch(updateAnswer(Number(event.target.value)));
  };
  const onEditorStateChange = (editorState) => {
    dispatch(updateAnswer(editorState));
  };

  return (
    <div className="question-component px-3">
      <div className="w-100 row p-0 justify-content-center">
        {!currentQuestion?.imgUrl ? (
          <></>
        ) : (
          <div className="col-3">
            <QuestionImgModal
              show={show}
              questionImg={currentQuestion.imgUrl}
              handleClose={handleImageModal}
            />
            <img
              className="w-100 question-figure"
              src={currentQuestion.imgUrl}
              alt="question-figure"
              onClick={handleImageModal}
            />
          </div>
        )}
        <div className="col-9">
          <h6>{currentQuestion.question}</h6>
          {type === "objective" && currentQuestion.numberOfAnswers === 1 && (
            <div
              className="d-flex flex-wrap pt-5 pb-3 new"
              onChange={handleChange}
            >
              {currentQuestion.options.map((label, i) => {
                if (!label) return <></>;
                return (
                  <Objective
                    option={alphabetArray[i]}
                    label={label}
                    idx={i}
                    key={i}
                    answer={currentQuestion.answer}
                  />
                );
              })}
            </div>
          )}
          {type === "objective" && currentQuestion.numberOfAnswers > 1 && (
            <div className="d-flex flex-wrap pt-5 pb-3 new">
              {currentQuestion.options.map((label, i) => {
                if (!label) return <></>;
                return (
                  <MultiSelect
                    option={alphabetArray[i]}
                    label={label}
                    idx={i}
                    key={i}
                    onChange={handleChange}
                    answer={currentQuestion.answer}
                  />
                );
              })}
            </div>
          )}
          {type === "subjective" && (
            <div className="" onChange={handleChange}>
              <Subjective />
            </div>
          )}
          {type === "theory" && (
            <div className="">
              <Editor
                key={currentQuestion.question}
                answer={currentQuestion.answer}
                onChange={onEditorStateChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Question.propTypes = {
  type: PropTypes.oneOf(["objective", "theory", "subjective"]).isRequired,
};

export default Question;
